import React from 'react';
import {Bar} from 'react-chartjs-2';
import { defaults } from 'react-chartjs-2';
import HoursChart from './charts/HoursChart';
import ClientChart from './charts/ClientChart';
import ServiceChart from './charts/ServiceChart';
import BillableChart from './charts/BillableChart';
import InvoicesClientChart from './charts/InvoicesClientChart';
import InvoicesChart from './charts/InvoicesChart';
import {COLORS, BILLABLE_COLORS} from "./ChartColors";

defaults.global.defaultColor = 'black';
defaults.global.defaultFontColor = 'black';
defaults.global.defaultFontFamily = 'Open Sans';
defaults.global.tooltips = {
  ...defaults.global.tooltips,
  ...{
    backgroundColor: 'white',
    titleFontColor: 'black',
    bodyFontColor: 'black',
    titleFontSize: 14,
    titleFontStyle: 'normal',
    bodyFontSize: 14,
    borderWidth: 1,
    borderColor: 'darkgrey',
    titleMarginBottom: 10,
    displayColors: false,
    xPadding: 15,
    yPadding: 15,
    caretSize: 8,
  }
}

const Reports = (props) => {
  const {
    hours_data,
    client_data,
    service_data,
    billable_data,
    client_invoices_data,
    invoices_data,
    custom_client_name
  } = props;

  return(
    <div style={{padding: '25px 0px'}}>
      {
        hours_data.labels && hours_data.labels.length > 0 &&
        <HoursChart {...{...hours_data, colors: COLORS}} />
      }
      {
        client_data.labels && client_data.labels.length > 0 &&
        <ClientChart {...{...client_data, custom_client_name, colors: COLORS}} />
      }
      {
        service_data.labels && service_data.labels.length > 0 &&
        <ServiceChart {...{...service_data, colors: COLORS}} />
      }
      {
        billable_data.labels && billable_data.labels.length > 0 &&
        <BillableChart {...{...billable_data, colors: BILLABLE_COLORS}} />
      }
      {
        client_invoices_data.labels && client_invoices_data.labels.length > 0 &&
        <InvoicesClientChart {...{...client_invoices_data, custom_client_name, colors: COLORS}} />
      }
      {
        invoices_data.labels && invoices_data.labels.length > 0 &&
        <InvoicesChart {...{...invoices_data, useCurrency: true, colors: COLORS}} />
      }
    </div>
  )
};

export default Reports;
